/** Delete the service worker's API cache (on logout / expired session),
 *  so nothing fetched while logged in is left on a shared phone. */
export default function clearApiCache() {
  if (typeof window === 'undefined' || !window.caches) return;
  window.caches
    .keys()
    .then((keys) => Promise.all(
      keys.filter((k) => k.startsWith('farm-africa-api-')).map((k) => window.caches.delete(k)),
    ))
    .catch(() => {
      // Best effort: private browsing or storage disabled.
    });
}
